/* Sekme tanımları — deep link karşılıkları (#program, #dresscode, …). */

export type TabId = "program" | "dresscode" | "atolyeler" | "aksam" | "konusmacilar";

export interface TabDef {
  id: TabId;
  labelKey: string;
}

export const TABS: TabDef[] = [
  { id: "program", labelKey: "navProgram" },
  { id: "dresscode", labelKey: "navDress" },
  { id: "atolyeler", labelKey: "navWorkshops" },
  { id: "aksam", labelKey: "navEvening" },
  { id: "konusmacilar", labelKey: "navSpeakers" },
];

export const isTabId = (v: string): v is TabId => TABS.some((t) => t.id === v);
